<div class="title-with-divider">
  <div class="title">
    <ng-content>{{ Title }}</ng-content>
  </div>
</div>
